import React from 'react';

import type { EventCard } from '@vlabs/monokit/shared/ui/event-card/';

import st from './Results.module.sass';
import { SearchResultCard } from './search-result-card/SearchResultCard';
import { SortFilter } from './sort-filter';
import { useSearchPageTranslation } from '../../i18n';
import { useSearch } from '../search-provider/SearchProvider';

interface ResultsProps {
  eventCard?: typeof EventCard;
}

function Results({ eventCard = undefined }: ResultsProps): React.JSX.Element {
  const { t } = useSearchPageTranslation();
  const { searchResults, candidateOrigin } = useSearch();

  const isResultsExists = searchResults !== undefined;

  return (
    <div
      className={st.Root}
      data-testid="search.results"
    >
      <div
        className={st.TitleWrapper}
        data-testid="search.results.title"
      >
        <div className={st.Title}>{t('results.title')}</div>
        {!!isResultsExists && <div className={st.ResultsQuantity}>{t('results.results_count.label', { count: searchResults.length, context: candidateOrigin })}</div>}
      </div>

      {!!isResultsExists && (
        <React.Fragment>
          <div className={st.Actions}>
            {/* <div>Здесь будут быстрые фильтры</div> */}
            <SortFilter />
          </div>
          <div
            className={st.Results}
            data-testid="search.results.list"
          >
            {searchResults.map((r) => (
              <SearchResultCard
                data={r}
                eventCard={eventCard}
                key={r.event_id ?? r.face_id}
              />
            ))}
          </div>
        </React.Fragment>
      )}

      {!isResultsExists && (
        <div
          className={st.Subtitle}
          data-testid="search.results.subtitle"
        >
          {t('results.no_data')}
        </div>
      )}
    </div>
  );
}

export { Results };
